import './App.css';
import { ChakraProvider } from '@chakra-ui/react';
import { Route, BrowserRouter, Routes, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import Dashboard from './pages/Dashboard';
import ForgotPassword from './pages/ForgotPassword';
import OTP from './pages/OTP';
import { createBrowserHistory } from 'history';

function getToken() {
  const tokenString = sessionStorage.getItem('data');
  const data = JSON.parse(tokenString);
  return data?.token || null;
}

function App() {
  const history = createBrowserHistory();
  const token = getToken();

  return (
    <ChakraProvider>
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              token ? (
                <Navigate to="/" replace />
              ) : (
                <Login />
              )
            }
          />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/Otp-verification" element={<OTP />} />
          <Route path="/*" element={<Dashboard />} />
          <Route path="*" element={<div>404 Not Found</div>} />
        </Routes>
      </BrowserRouter>
    </ChakraProvider>
  );
}

export default App;
